import { CSSProperties } from 'styled-components';

import { FullViewportScroll } from '@sorare/core/src/atoms/container/FullViewportScroll';
import { RadioGroup } from '@sorare/core/src/atoms/inputs/RadioGroup';
import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';

import { usePaymentContext } from 'components/buyActions/Context';

import { PaymentBoxBlockV2 } from '../ui';
import { useOrderedPaymentMethods } from './useOrderedPaymentMethods';

type Props = {
  onlyCreditCards?: boolean;
};

export const Methods = ({ onlyCreditCards = false }: Props) => {
  const isTablet = useIsTabletAndAbove();
  const {
    currencyAvailableOptions,
    selectedOptionConfig,
    setSelectedOptionConfig: setSelectedPaymentMethod,
  } = usePaymentContext();

  const selectedPaymentMethod = selectedOptionConfig?.value;

  useOrderedPaymentMethods({
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    onlyCreditCards,
    currencyAvailableOptionsValues: currencyAvailableOptions.map(o => o.value),
  });

  if (currencyAvailableOptions.length === 1)
    return (
      <PaymentBoxBlockV2 gap={0}>
        {currencyAvailableOptions[0].labelContent}
        {currencyAvailableOptions[0].Content?.({ isSelected: true })}
      </PaymentBoxBlockV2>
    );

  return (
    <PaymentBoxBlockV2
      gap={0}
      style={
        {
          '--radio-width': isTablet ? 'auto' : '30%',
          '--radio-padding':
            'var(--intermediate-unit) var(--intermediate-unit) var(--unit) var(--intermediate-unit)',
          '--radio-group-gap': 'var(--unit)',
        } as CSSProperties
      }
      fullWidth={!isTablet}
    >
      {currencyAvailableOptions.length === 0 ? (
        <LoadingIndicator small />
      ) : (
        <FullViewportScroll>
          <RadioGroup
            name="methods"
            hideRadio
            border
            row
            modal
            rounded
            center={false}
            value={selectedOptionConfig?.value}
            onChange={value => {
              setSelectedPaymentMethod(value);

              currencyAvailableOptions
                .find(
                  currencyAvailableOption =>
                    currencyAvailableOption.value === value
                )
                ?.onChange?.();
            }}
            options={currencyAvailableOptions.map(option => {
              return {
                label: option.labelContent,
                value: option.value,
                disabled: option.disabled,
              };
            })}
          />
        </FullViewportScroll>
      )}
      {selectedOptionConfig?.Content?.({ isSelected: true })}
    </PaymentBoxBlockV2>
  );
};

export default Methods;
